import React, { ErrorInfo } from 'react';
import { ErrorProvider } from './ErrorBoundaryContext';
import { ErrorComponent } from '../ErrorView/ErrorView';
import { ApplicationResolution } from '../applicationResolution';
import { AppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';

interface Props {
  children: React.ReactNode;
}

type State = {
  error?: Error;
  errorInfo?: ErrorInfo;
};

class ErrorBoundary extends React.Component<Props, State> {
  state: State = {};
  static contextType = AppFeaturesContext;
  context!: React.ContextType<typeof AppFeaturesContext>;

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    const features = this.context;
    return (
      <ErrorProvider
        errorBoundaryError={this.state.error}
        errorBoundaryErrorInfo={this.state.errorInfo}
      >
        {this.state.error ? (
          <div
            style={{
              height:
                features.applicationResolution === ApplicationResolution.FULLHD
                  ? '1080p'
                  : '720p',
            }}
          >
            <ErrorComponent errorName={this.state.error?.name ?? 'Error'} />
          </div>
        ) : (
          this.props.children
        )}
      </ErrorProvider>
    );
  }
}

export default ErrorBoundary;
